const momentumScroll = {
	mounted(el, binding) {
		const isTouchDevice = () => {
			return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
		}

		if (isTouchDevice()) {
			console.warn('Momentum scroll NOT applied - device is a touch device')
		} else {
			console.warn('Momentum scroll applied')
		}

		const minStartVelocity = binding.value?.minVelocity || 5 // px/s
		const maxScrollTime = binding.value?.maxScrollTime || 1500 // ms

		let isScrolling = false
		let startY = 0
		let startScrollTop = 0
		let velocity = 0
		let lastY = 0
		let lastTime = 0
		let animationFrame = null
		let resizeObserver = null

		// Check overflow and toggle class
		const checkOverflow = () => {
			if (el.scrollHeight > el.clientHeight) {
				el.classList.add('has-overflow')
			} else {
				el.classList.remove('has-overflow')
			}
		}

		// Handle scroll visibility
		const handleScroll = () => {
			el.classList.add('active-scroll')
			clearTimeout(el._scrollTimeout)
			el._scrollTimeout = setTimeout(() => {
				el.classList.remove('active-scroll')
			}, 1000)
		}

		function handleMouseDown(event) {
			console.log('handleMouseDown')

			// Check if the target is a focusable element (input, textarea, select, button, [contenteditable])
			const isFocusable = ['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON'].includes(event.target.tagName) || event.target.hasAttribute('contenteditable') || event.target.hasAttribute('tabindex')

			// If the target is a focusable element, allow default behavior (focusing)
			if (isFocusable) {
				return
			}

			if (animationFrame) {
				cancelAnimationFrame(animationFrame)
				animationFrame = null
			}
			isScrolling = true
			startY = event.clientY
			startScrollTop = el.scrollTop
			velocity = 0
			lastY = event.clientY
			lastTime = Date.now()
			window.addEventListener('mousemove', handleMouseMove)
			window.addEventListener('mouseup', handleMouseUp)
			el._momentumScroll = { handleMouseMove, handleMouseUp }
			event.preventDefault()
		}

		function handleMouseMove(event) {
			if (!isScrolling) return
			const currentY = event.clientY
			const deltaY = currentY - startY
			const maxScrollTop = el.scrollHeight - el.clientHeight
			const newScrollTop = startScrollTop - deltaY
			el.scrollTop = Math.max(0, Math.min(newScrollTop, maxScrollTop))
			const currentTime = Date.now()
			const timeDiff = currentTime - lastTime
			if (timeDiff > 0) {
				const distance = currentY - lastY
				velocity = distance / timeDiff // Pixels per millisecond
			}
			lastY = currentY
			lastTime = currentTime
			event.preventDefault()
		}

		function handleMouseUp() {
			isScrolling = false
			window.removeEventListener('mousemove', handleMouseMove)
			window.removeEventListener('mouseup', handleMouseUp)
			delete el._momentumScroll
			const velocityPxPerSec = velocity * 1000 // Convert to pixels per second
			if (Math.abs(velocityPxPerSec) > minStartVelocity) {
				startMomentumScroll(-velocityPxPerSec)
			}
		}

		function startMomentumScroll(initialVelocity) {
			let velocity = initialVelocity // Initial velocity in px/s
			let lastTime = Date.now()
			const deceleration = 2000 // px/s²
			const startTime = Date.now()

			function animate() {
				const currentTime = Date.now()
				const deltaTime = (currentTime - lastTime) / 1000 // Time step in seconds
				lastTime = currentTime

				const decelerationStep = deceleration * deltaTime
				if (velocity > 0) {
					velocity = Math.max(0, velocity - decelerationStep)
				} else if (velocity < 0) {
					velocity = Math.min(0, velocity + decelerationStep)
				}

				const deltaScroll = velocity * deltaTime
				const maxScrollTop = el.scrollHeight - el.clientHeight
				const newScrollTop = el.scrollTop + deltaScroll
				el.scrollTop = Math.max(0, Math.min(newScrollTop, maxScrollTop))

				if ((el.scrollTop <= 0 && velocity < 0) || (el.scrollTop >= maxScrollTop && velocity > 0)) {
					velocity = 0
				}

				const elapsed = currentTime - startTime
				if (elapsed < maxScrollTime && Math.abs(velocity) > 0) {
					animationFrame = requestAnimationFrame(animate)
				} else {
					animationFrame = null
				}
			}

			animationFrame = requestAnimationFrame(animate)
		}

		// Initial setup
		checkOverflow()
		resizeObserver = new ResizeObserver(() => {
			checkOverflow()
		})
		resizeObserver.observe(el)

		// Add event listeners
		if (!isTouchDevice()) {
			el.addEventListener('mousedown', handleMouseDown)
			el._momentumScrollHandleMouseDown = handleMouseDown
		}
		el.addEventListener('scroll', handleScroll)

		// Store for cleanup
		el._resizeObserver = resizeObserver
	},

	unmounted(el) {
		if (el._momentumScrollHandleMouseDown) {
			el.removeEventListener('mousedown', el._momentumScrollHandleMouseDown)
			delete el._momentumScrollHandleMouseDown
		}
		if (el._momentumScroll) {
			window.removeEventListener('mousemove', el._momentumScroll.handleMouseMove)
			window.removeEventListener('mouseup', el._momentumScroll.handleMouseUp)
			delete el._momentumScroll
		}
		if (el._resizeObserver) {
			el._resizeObserver.unobserve(el)
			el._resizeObserver.disconnect()
			delete el._resizeObserver
		}
		if (el._scrollTimeout) {
			clearTimeout(el._scrollTimeout)
			delete el._scrollTimeout
		}
		el.removeEventListener('scroll', el._handleScroll) // Note: This might need adjustment if handleScroll is stored differently
	},
}

export default momentumScroll
